import {Component, EventEmitter, Input, Output} from '@angular/core';
import {animate, style, transition, trigger} from "@angular/animations";

@Component({
	selector: 'fb-filter-sort-dropdown',
	animations: [
		trigger('enterAnimation', [
			transition(':enter', [
				style({transform: 'translateX(0)', opacity: 0}),
				animate(
					'200ms',
					style({transform: 'translateX(0)', opacity: 1})
				),
			]),
			transition(':leave', [
				style({transform: 'translateX(0)', opacity: 1}),
				animate(
					'200ms',
					style({transform: 'translateX(0)', opacity: 0})
				),
			]),
		]),
	],
	templateUrl: './filter-sort-dropdown.component.html',
	styleUrls: ['./filter-sort-dropdown.component.scss']
})
export class FilterSortDropdownComponent {

	@Input()
	public selectedSortOption: string = 'date';
	@Output()
	public sortOption: EventEmitter<string> = new EventEmitter<string>();

	public sortShow: boolean = false;

	public sort(type: string): void {
		this.sortOption.emit(type);
	}
}
